export default class Validator {
  constructor() {
    this.isValid = true;
    this.validationMessage = '';
    this.tested = false;
    this.humanValidated = false;
  }

  invalidate(message) {
    this.validationMessage = message;
    this.isValid = false;
  }

  validate(input, humanValidated = false) {
    // Implemented in subclass
    this.tested = true;
    this.humanValidated = humanValidated;
    return true;
  }

  clear() {
    this.isValid = true;
    this.tested = false;
    this.humanValidated = false;
  }
}
